import React, { useState, useEffect, useRef } from "react";

import '../../App.css';
import Header from "../../Components/Header/Header";
import LeftMenu from "../../Components/LeftMenu/LeftMenu";

import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faBox, faHouseUser } from '@fortawesome/free-solid-svg-icons';

import { Button, Dropdown } from 'react-bootstrap';
import User from "../../assets/images/user.png";
import Flight from "../../assets/images/Flight.png";
import SReco from "../../assets/images/serv_reco.png";
import Monitor from "../../assets/images/Monitor.png";
import Rfs from "../../assets/images/Rfs.png";
import Uldm from "../../assets/images/Uldm.png";
import Ulddam from "../../assets/images/ulddam.png";
import Settings from "../../assets/images/settings.png";
import Cusreport from "../../assets/images/cusreport.svg";
import Claim from "../../assets/images/claim.svg";
import Surv from "../../assets/images/surv.png";
import Driver from "../../assets/images/driver.png";

import Semester from "../../assets/images/semester.png";
import Events from "../../assets/images/events.png";
import Learing from "../../assets/images/e-learing.png";
import Inspection from "../../assets/images/inspection.png";
import Quality from "../../assets/images/quality.png";
import License from "../../assets/images/pick-list.png";
import rfstruck from "../../assets/images/rfstruck.png"

import Truck_info from "../../assets/images/truck-inspection.png"
import Export_in from "../../assets/images/export_en.png"

import { toast } from 'react-toastify';

import { setRedirecting } from "../../App";
import { withoutRFSToken, withRFSToken } from '../../Services/axios';
import { useUserCheckQuery } from "../../redux/services/Auth";
import { AddSession } from "../../useAuth/SessionExtract";

const Dashboard = () => {

    localStorage.removeItem("MainTab");
    localStorage.removeItem("InnerPage");
    localStorage.removeItem('tab');
    localStorage.removeItem('STab');
    localStorage.removeItem('SubTab');
    localStorage.removeItem('DetailsTitle');
    localStorage.removeItem('PreFilter');
    const tokenTypes = ['airlinetoken', 'forwardertoken', 'email_approval_token'];
    const history = useHistory();
    const isMounted = useRef(false);
    const [authLoading, setAuthLoading] = useState(true);

    // const userType = localStorage.getItem('User');
    // const user = localStorage.getItem('UserType');
    // const orgType = localStorage.getItem('OrgType');
    // const Email = localStorage.getItem('Email');
    // const Phone = localStorage.getItem('Phone');
    // const Portal = localStorage.getItem('portal');
    const loginFrom = localStorage.getItem('login_from');
    // console.log("🚀 ~ Dashboard ~ orgType:", orgType)

    const initial = loginFrom == 'cclp' ? 'CCLP' : 'CDM';

    const [dashboardNav, setDashboardNav] = useState(initial);
    const [navItems, setNavItems] = useState([]);
    const [userDetails, setUserDetails] = useState();

    const handleClickNav = (item) => {
        setDashboardNav(item)
    }
    // const fetchTimeZone = async () => {
    //     try {
    //         const res = await withRFSToken.get("organization-timezone/get")
    //         .then(function (res) {
    //             const innerData = res.data.response_data;
    //           localStorage.setItem("timeZone", JSON.stringify(innerData))
    //         });

    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };
    // useEffect(() => {
    //     if (isMounted.current) return;
    //      fetchTimeZone();
    //     isMounted.current = true;
    // },[])
    // const dz = { offset: "+01:00", zone: "Europe/Berlin", label: "CET (Central European Time)" }
    // localStorage.setItem("timeZone", JSON.stringify(dz))

    // let navItems;
    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            const userType = myData?.response_data?.user_name;
            const user = myData?.response_data?.user_type;
            const orgType = myData?.response_data?.org_type;
            const Email = myData?.response_data?.email_id;
            const Phone = myData?.response_data?.user_number;
            const Portal = myData?.response_data?.portal;
            const loginFrom = myData?.response_data?.login_from;
            setUserDetails(myData?.response_data);

            if (orgType == 'H') {
                if (dashboardNav == 'CDM') {
                    setNavItems([
                        // { name: 'AWB Monitor', path: () => handlerControl(''), image: Monitor },
                        // { name: 'Flight Monitor', path: () => handlerControl(''), image: Flight },
                        { name: 'RFS Control Tower', path: () => handlerControl('RFS'), image: Rfs },
                        // { name: 'Slot Planning', path: () => window.location.href ='https://portal.trucking.aero/Forms/bookinglist_handler?tab=planning', image: rfstruck }, // not live
                        { name: 'Slot Planning', path: () => handlerControl('SPL'), image: rfstruck },
                        { name: 'ULD Control', path: () => handlerControl('ULD'), image: Uldm },
                        { name: 'Service Recovery', path: () => handlerControl('ASR'), image: Settings },
                        { name: 'Driver/Visitor Registration', path: () => handlerControl('DVR'), image: Driver },
                        { name: 'Security', path: () => handlerControl('SEC'), image: Settings },
                    ]);
                } else if (dashboardNav == 'CCLP') {
                    setNavItems([
                        { name: 'Cargo Damage', path: () => airlineCCLP('cargo-damage'), image: SReco },
                        { name: 'ULD Damage', path: () => airlineCCLP('uld-damage'), image: Ulddam },
                        { name: 'Work Order', path: () => airlineCCLP('work-order'), image: Uldm },
                        { name: 'Truck Inspection', path: () => airlineCCLP('truck-inspection'), image: rfstruck },
                        { name: 'Customer Report', path: () => airlineCCLP('customer-report'), image: Claim },
                        { name: 'Surveillance', path: () => airlineCCLP('surveillance'), image: Surv },

                    ]);
                } else if (dashboardNav == 'QMS') {
                    setNavItems([
                        { name: 'Audit Control', path: () => handlerControl(''), image: Inspection },
                        { name: 'Event Manager', path: () => handlerControl(''), image: Events },
                        { name: 'Training Manager', path: () => handlerControl(''), image: Learing },
                        { name: 'Training Scheduler', path: () => handlerControl(''), image: Semester },
                        { name: 'Document Manager', path: () => handlerControl(''), image: Quality },
                        { name: 'License Manager', path: () => handlerControl(''), image: License },
                    ]);
                }
            } else if (orgType == 'A') {
                if (dashboardNav == 'CDM') {

                    setNavItems([
                        { name: 'AWB Monitor', path: () => airlineControl('AWBM'), image: Monitor },
                        { name: 'Flight Monitor', path: () => airlineControl('FTM'), image: Flight },
                        { name: 'Truck Monitor', path: () => airlineControl('TKM'), image: Flight },
                        { name: 'RFS Monitor', path: () => airlineControl('RFSM'), image: Flight },
                        { name: 'RFS Control Tower', path: () => airlineControl('RFS'), image: Rfs },
                        { name: 'ULD Control', path: () => airlineControl('ULD'), image: Uldm },
                        { name: 'Service Recovery', path: () => airlineControl('ASR'), image: Settings },
                        // { name: 'Free Account', path: () => airlineControl('token'), image: Settings },
                    ]);
                } else if (dashboardNav == 'CCLP') {
                    setNavItems([
                        { name: 'Cargo Damage', path: () => airlineCCLP('cargo-damage'), image: SReco },
                        { name: 'ULD Damage', path: () => airlineCCLP('uld-damage'), image: Ulddam },
                        { name: 'Customer Report', path: () => airlineCCLP('customer-report'), image: Cusreport },
                        { name: 'Cargo Claims', path: () => airlineCCLP('cargo-claim'), image: Claim },
                        { name: 'Truck Inspection', path: () => airlineCCLP('truck-inspection'), image: Truck_info },
                    ]);
                } else if (dashboardNav == 'QMS') {
                    setNavItems([
                        { name: 'Audit Control', path: () => airlineControl(''), image: Inspection },
                        { name: 'Event Manager', path: () => airlineControl(''), image: Events },
                        { name: 'Training Manager', path: () => airlineControl(''), image: Learing },
                        { name: 'Training Scheduler', path: () => airlineControl(''), image: Semester },
                        { name: 'Document Manager', path: () => airlineControl('QMS', 'doc_mgmt'), image: Quality },
                        { name: 'License Manager', path: () => airlineControl(''), image: License },
                    ]);
                }
            } else if (orgType == 'E') {
                if (dashboardNav == 'CDM') {
                    setNavItems([
                        // { name: 'AWB Monitor', path: () => airlineControl(''), image: Monitor },
                        // { name: 'Flight Monitor', path: () => airlineControl(''), image: Flight },
                        { name: 'Shipment Manager', path: () => forwarderControl('RFS'), image: Rfs },
                        { name: 'ULD Control', path: () => forwarderControl('ULD'), image: Uldm }, // () => window.location.href ='http://truckingprod.mydemowork.co.in/Forms/Forwarders/forwarder-bookinglist_admin?tab=uld'
                        { name: 'Driver/Visitor Registration', path: () => forwarderControl('DVR'), image: Driver },
                        { name: 'Quotation', path: () => forwarderControl('QUT'), image: Driver },
                        // { name: 'ULD Control', path: () => window.location.href ='https://portal.trucking.aero/Forms/Forwarders/forwarder-bookinglist_admin?tab=uld', image: Uldm }, // not live
                    ]);
                } else if (dashboardNav == 'CCLP') {
                    setNavItems([
                        { name: 'Cargo Claim', path: () => airlineCCLP('cargo-claim'), image: Claim },
                        { name: 'Cargo Image', path: () => airlineCCLP('cargo-image'), image: Ulddam },
                        { name: 'Export Acceptance', path: () => airlineCCLP('export-acceptance'), image: Export_in },
                        { name: 'Truck Inspection', path: () => airlineCCLP('truck-inspection'), image: Truck_info },
                        { name: 'Cargo Damage', path: () => airlineCCLP('cargo-damage-forwarder'), image: SReco },
                    ]);
                } else if (dashboardNav == 'QMS') {
                    setNavItems([
                        { name: 'Audit Control', path: () => airlineControl(''), image: Inspection },
                        { name: 'Event Manager', path: () => airlineControl(''), image: Events },
                        { name: 'Training Manager', path: () => airlineControl(''), image: Learing },
                        { name: 'Training Scheduler', path: () => airlineControl(''), image: Semester },
                        { name: 'Document Manager', path: () => airlineControl(''), image: Quality },
                        { name: 'License Manager', path: () => airlineControl(''), image: License },
                    ]);
                }
            } else if (Portal) {
                if (dashboardNav == 'CDM') {
                    setNavItems([
                        // { name: 'AWB Monitor', path: () => airlineControl(''), image: Monitor },
                        // { name: 'Flight Monitor', path: () => airlineControl(''), image: Flight },
                        // { name: 'Shpment Manager', path: () => forwarderControl('RFS'), image: Rfs },
                        // { name: 'ULD Control', path: () => forwarderControl('ULD'), image: Uldm },
                    ]);
                } else if (dashboardNav == 'CCLP') {
                    setNavItems([
                        { name: 'Cargo Damage', path: () => airlineCCLP('cargo-damage'), image: SReco },
                        { name: 'ULD Damage', path: () => airlineCCLP('uld-damage'), image: Ulddam },
                        { name: 'Service Recovery', path: () => airlineControl('ASR'), image: Settings },
                        { name: 'Customer Report', path: () => airlineCCLP('customer-report'), image: Cusreport },
                        { name: 'Cargo Claims', path: () => airlineCCLP('cargo-claim'), image: Claim },
                    ]);
                } else if (dashboardNav == 'QMS') {
                    setNavItems([
                        // { name: 'Audit Control', path: () => airlineControl(''), image: Inspection },
                        // { name: 'Event Manager', path: () => airlineControl(''), image: Events },
                        // { name: 'Training Manager', path: () => airlineControl(''), image: Learing },
                        // { name: 'Training Scheduler', path: () => airlineControl(''), image: Semester },
                        // { name: 'Document Manager', path: () => airlineControl(''), image: Quality },
                        // { name: 'License Manager', path: () => airlineControl(''), image: License },
                    ]);
                }
            }
            setAuthLoading(false)
        }
    }, [myData, dashboardNav]);




    const airlineControl = (item, sec) => {
        const tokenValue = localStorage.getItem('airlinetoken');

        // if (!tokenValue) {
        //     console.log("No 'airlinetoken' found in local storage.");
        //     return;
        // }

        if (!item) {
            toast.warning('Page is not available right now');
            return;
        }

        const keysToClear = ['ULD', 'RFS', 'ASR', 'FTM', 'QMS', 'SPL'];

        const routeMap = {
            ULD: process.env.REACT_APP_ULD_URL,
            // RFS: process.env.REACT_APP_BOOKINGTRUCK_URL,
            RFS: '/RFSDashboard',
            FTM: '/FlightMonitor',
            TKM: '/TruckMonitor',
            ASR: process.env.REACT_APP_ASR_URL,
            RFSM: '/RFSMonitor',
            token: 'PlanDashboard',
            // AWBM has no redirect (as per your code)
            QMS: sec === 'doc_mgmt' ? '/DocumentManagement' : null
        };
        if (['ASR', 'RFSM'].includes(item)) {
        } else {

            // const addUrl = {...userDetails, module: item}
            // AddSession('__A-', addUrl)
            // keysToClear.forEach(key => localStorage.removeItem(key));

            // localStorage.setItem(item, tokenValue);
            // localStorage.removeItem('airlinetoken');
            // localStorage.removeItem('EMAIL');
        }


        const redirectUrl = routeMap[item];
        if (redirectUrl) {
            setRedirecting(true);
            window.location.replace(redirectUrl);
        }

        // if (tokenValue) {
        //     if (item !== '') {
        //         localStorage.setItem(item, tokenValue);  // Set the value under the new key
        //         localStorage.removeItem('airlinetoken');
        //         if (item === 'ULD') {
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('FTM');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace(process.env.REACT_APP_ULD_URL)
        //         } else if (item === 'RFS') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('FTM');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace(process.env.REACT_APP_BOOKINGTRUCK_URL)
        //         } else if (item === 'AWBM') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('FTM');
        //             localStorage.removeItem('QMS');
        //             // setRedirecting(true);
        //             // window.location.replace('https://portal.trucking.aero/Forms/bookinglist_airline')
        //         } else if (item === 'FTM') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace('/FlightMonitor')
        //         } else if (item === 'TKM') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace('/TruckMonitor')
        //         } else if (item === 'ASR') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('FTM');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace(process.env.REACT_APP_ASR_URL)
        //         } else if (item === 'token') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('FTM');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace('PlanDashboard')
        //         } else if (item === 'QMS') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('SPL');
        //             localStorage.removeItem('FTM');
        //             setRedirecting(true);
        //             // window.location.replace(process.env.REACT_APP_BOOKINGTRUCK_URL)
        //             if (sec === 'doc_mgmt') {
        //                 window.location.replace('/DocumentManagement')
        //             }
        //         } else { }
        //         localStorage.removeItem('EMAIL');
        //     } else {
        //         toast.warning('Page is not avaiable right now')
        //     }

        // } else {
        //     console.log("No 'airlinetoken' found in local storage.");
        // }
    };
    const handlerControl = (item, sec) => {
        // const tokenValue = localStorage.getItem('airlinetoken');

        // if (!tokenValue) {
        //     console.log("No 'airlinetoken' found in local storage.");
        //     return;
        // }

        if (!item) {
            toast.warning('Page is not available right now');
            return;
        }
        const keysToClear = ['ULD', 'RFS', 'ASR', 'SPL', 'QMS'];
        const routeMap = {
            ULD: process.env.REACT_APP_ULD_URL,
            RFS: '/HandlerTruckMonitor',
            ASR: process.env.REACT_APP_ASR_URL,
            SPL: '/SlotPlanning',
            DVR: '/DVRegistration',
            SEC: '/Security',
        };
        if (['SPL', 'SEC'].includes(item)) {

        } else {
            keysToClear.forEach(key => localStorage.removeItem(key));

            const addUrl = { ...userDetails, module: item }
            AddSession('__A-', addUrl)
            // localStorage.setItem(item, tokenValue);

            // if (item === 'RFS') {
            //     localStorage.setItem('SPL', tokenValue);
            // }

            // localStorage.removeItem('airlinetoken');
            // localStorage.removeItem('EMAIL');
        }


        const redirectUrl = routeMap[item];
        if (redirectUrl) {
            setRedirecting(true);
            window.location.replace(redirectUrl);
        }
        // if (tokenValue) {
        //     if (item !== '') {
        //         localStorage.setItem(item, tokenValue);  // Set the value under the new key
        //         localStorage.removeItem('airlinetoken');
        //         if (item === 'ULD') {
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('SPL');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace(process.env.REACT_APP_ULD_URL)
        //         } else if (item === 'RFS') {
        //             // localStorage.removeItem('ULD');
        //             // localStorage.removeItem('ASR');
        //             // localStorage.setItem('Htab', 'orders');
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('QMS');
        //             localStorage.setItem('SPL', tokenValue);
        //             setRedirecting(true);
        //             // window.location.replace(process.env.REACT_APP_BOOKINGTRUCK_URL)
        //             window.location.replace('/HandlerTruckMonitor')
        //         } else if (item === 'ASR') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('SPL');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             window.location.replace(process.env.REACT_APP_ASR_URL)
        //         } else if (item === 'SPL') {
        //             localStorage.removeItem('ULD');
        //             localStorage.removeItem('ASR');
        //             localStorage.removeItem('RFS');
        //             localStorage.removeItem('QMS');
        //             setRedirecting(true);
        //             // window.location.replace(process.env.REACT_APP_BOOKINGTRUCK_URL)
        //             window.location.replace('/PlanningDashboard')
        //         } else { }
        //         localStorage.removeItem('EMAIL');
        //     } else {
        //         toast.warning('Page is not avaiable right now')
        //     }

        // } else {
        //     console.log("No 'airlinetoken' found in local storage.");
        // }
    };
    const airlineCCLP = async (tab) => { //('cclp-login', { tab_name: tab }) withRFSToken.post('switch-to-cclp', { module_name: tab })
        try {
            const res = await withRFSToken.post('switch-to-cclp', { module_name: tab })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    window.location.replace(innerData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const forwarderControl = (item) => {
        const tokenValue = localStorage.getItem('airlinetoken');
        const shpTab = localStorage.getItem('FSTab');
        localStorage.removeItem('Maintab');

        // if (tokenValue) {
            if (item !== '') {
                const itemKey = item == "QUT" ? "RFS" : item;
                localStorage.setItem(itemKey, tokenValue);  // Set the value under the new key
                localStorage.removeItem('airlinetoken');
                if (item === 'ULD') {
                    localStorage.removeItem('RFS');
                    localStorage.removeItem('ASR');
                    localStorage.removeItem('DVR');
                    setRedirecting(true);
                    window.location.replace('/ULDForwarder')
                } else if (item === 'RFS') {
                    localStorage.removeItem('ULD');
                    localStorage.removeItem('ASR');
                    localStorage.removeItem('DVR');
                    setRedirecting(true);
                    if (shpTab) {
                        window.location.replace(`/ForwarderShipments/${shpTab}`)
                    } else {
                        window.location.replace('/ForwarderShipments/ShipmentRecords')
                    }
                } else if (item === 'ASR') {
                    localStorage.removeItem('ULD');
                    localStorage.removeItem('RFS');
                    localStorage.removeItem('DVR');
                    setRedirecting(true);
                    window.location.replace(process.env.REACT_APP_ASR_URL)
                } else if (item === 'DVR') {
                    localStorage.removeItem('ULD');
                    localStorage.removeItem('RFS');
                    localStorage.removeItem('ASR');
                    setRedirecting(true);
                    window.location.replace('/DVRegistration')
                } else if (item === 'QUT') {
                    localStorage.removeItem('ULD');
                    // localStorage.removeItem('RFS');
                    localStorage.removeItem('QUTpage');
                    localStorage.removeItem('ASR');
                    localStorage.removeItem('DVR');
                    setRedirecting(true);
                    // history.push('/Quotation')
                    window.location.replace('/Quotation')
                } else { }
                localStorage.removeItem('EMAIL');
            } else {
                toast.warning('Page is not avaiable right now')
            }

        // } else {
        //     console.log("No 'airlinetoken' found in local storage.");
        // }
    };

    const serverPage = () => {
        const tokenValue = localStorage.getItem('airlinetoken');
        localStorage.setItem('ServerIWI', tokenValue);
        localStorage.removeItem('airlinetoken');
        window.location.replace('/Server')
    }

    return (
        <>
            {/* {console.log('navItems', navItems)} */}
            {/* {console.log('userDetails => dash', userDetails)} */}
            <div className="dashboard">
                <Header page_type={userDetails?.org_type == 'H' ? 'handler' : (userDetails?.org_type == 'A' ? 'airline' : 'forwarder')} logo_url='/Dashboard' mode='SA' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel">
                        {/* {orgType === 'airlinetoken' && 
                        <>
                        <Link to='#' onClick={() => airlineCDM('RFS')}> RFS Control</Link> ||
                        <Link to='#' onClick={() => airlineCDM('ULD')}> ULD Control</Link>
                        </>
                        } */}
                        <div className="">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="dashboard_prfl_dv">
                                        <div className="dshbrd_prfl_details">
                                            <div className="prfl_bg_icon">
                                                <img src={User} />
                                            </div>
                                            <div className="prfl_nm_dtls">
                                                <h4 className="mb-0">{userDetails?.user_name ? userDetails?.user_name : ''}</h4>
                                                <p className="mb-0">{userDetails?.org_type === 'A' ? 'Airline' : (userDetails?.org_type === 'H' ? 'Handler' : (userDetails?.org_type === 'F' ? 'Forwarer' : ''))}</p>
                                            </div>
                                        </div>
                                        <div className="dshbrd_content">
                                            <h6>About this content</h6>
                                            <p className="mb-2 text-secondary"><span className="tym_zone">Time Zone</span><span>UTC/GMT + 7 hours</span></p>
                                            <p className="mb-2 text-secondary"><span className="personal_mail">Personal Mail</span><span><a href="javascrip:void()">{userDetails?.email_id}</a></span></p>
                                            <p className="mb-2 text-secondary"><span className="work_mail">Work Mail</span><span><a href="javascrip:void()">{userDetails?.email_id}</a></span></p>
                                            <p className="mb-2 text-secondary"><span className="ph_no">Phone</span><span>{userDetails?.user_number}</span></p>
                                            <p className="mb-2 text-secondary"><span className="ph_no">Station</span><span> </span></p>
                                            <p className="mb-2 text-secondary"><span className="ph_no">User Role</span><span> </span></p>
                                            {userDetails?.login_user_type == 'SA' && <><p className="mb-2 text-secondary"><span className="ph_no">Server Details</span><span><Link to='#' onClick={serverPage}>Click Here</Link> </span></p></>}
                                            {/* <p className="mb-2 text-secondary"><span className="descp">Description</span><span>cvjldsjldkjds</span></p> */}
                                        </div>
                                    </div>
                                    {!userDetails?.portal &&
                                        <div className={dashboardNav === 'CDM' ? 'cdm cdm_active mt-3' : 'cdm mt-3'} onClick={() => handleClickNav('CDM')}>
                                            <div className="cdm_icon">
                                                <span><FontAwesomeIcon icon={faPlane} /></span>
                                            </div>
                                            <div className="cdm_details">
                                                <h6 className="mb-0">CDM</h6>
                                                <p className="mb-0">Manage Cargo Movements</p>
                                            </div>
                                        </div>
                                    }
                                    <div className={dashboardNav === 'CCLP' ? 'cdm cdm_active mt-3' : 'cdm mt-3'} onClick={() => handleClickNav('CCLP')}>
                                        <div className="cdm_icon">
                                            <span><FontAwesomeIcon icon={faBox} /></span>
                                        </div>
                                        <div className="cdm_details">
                                            <h6 className="mb-0">CCLP</h6>
                                            <p className="mb-0">Registration and Incident Management</p>
                                        </div>
                                    </div>
                                    {!userDetails?.portal &&
                                        <div className={dashboardNav === 'QMS' ? 'cdm cdm_active mt-3' : 'cdm mt-3'} onClick={() => handleClickNav('QMS')}>
                                            <div className="cdm_icon">
                                                <span><FontAwesomeIcon icon={faHouseUser} /></span>
                                            </div>
                                            <div className="cdm_details">
                                                <h6 className="mb-0">QMS</h6>
                                                <p className="mb-0">Quality Management System</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="col-md-6">
                                    <div className="dashboard_prfl_dv h-100">
                                        {/* {dashboardNav == 'CDM' &&
                                            <> */}
                                        <h6>{dashboardNav == 'CDM' ? 'CDM' : dashboardNav == 'CCLP' ? 'CCLP' : 'QMS'}</h6>
                                        <div className="main-dv position-relative">
                                            {authLoading ?
                                                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}>
                                                    <span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span>
                                                </div>
                                                :
                                                <>
                                                    {navItems?.map((item, index) => (
                                                        <div className="dv1" key={index} onClick={item.path}>
                                                            <div className="icons mb-2">
                                                                <img src={item.image} />
                                                            </div>
                                                            <div className="icon_txt">
                                                                <p className="mb-0">{item.name}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            }
                                        </div>
                                        {/* </>
                                        } */}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="module_updates h-100">
                                        <h6>Module Updates</h6>
                                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link active nav_active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">CDM</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">CCLP</button>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">QMS</button>
                                            </li>
                                        </ul>
                                        <div className="tab-content" id="pills-tabContent">
                                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                                <div className="module_updt_wrap_dv mb-2">
                                                    <div className="module_bg_icon">
                                                        <span className="fw-bold">CD</span>
                                                    </div>
                                                    <div className="module_txt">
                                                        <h4>New ULD found action option added</h4>
                                                        <p className="mb-0"><span>ULD Control</span><span>20sep,2024</span></p>
                                                    </div>
                                                </div>
                                                <div className="module_updt_wrap_dv mb-2">
                                                    <div className="module_bg_icon">
                                                        <span className="fw-bold">CD</span>
                                                    </div>
                                                    <div className="module_txt">
                                                        <h4>New Asign action option added</h4>
                                                        <p className="mb-0"><span>RFS Control Tower</span><span>20sep,2024</span></p>
                                                    </div>
                                                </div>
                                                <div className="module_updt_wrap_dv mb-2">
                                                    <div className="module_bg_icon">
                                                        <span className="fw-bold">CD</span>
                                                    </div>
                                                    <div className="module_txt">
                                                        <h4>New ULD found action option added</h4>
                                                        <p className="mb-0"><span>AWB Monitor</span><span>20sep,2024</span></p>
                                                    </div>
                                                </div>
                                                <div className="module_updt_wrap_dv mb-2">
                                                    <div className="module_bg_icon">
                                                        <span className="fw-bold">CD</span>
                                                    </div>
                                                    <div className="module_txt">
                                                        <h4>New ULD found action option added</h4>
                                                        <p className="mb-0"><span>ULD Control</span><span>20sep,2024</span></p>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"><span className="w-100 text-center d-block">No CCLP module updates available</span></div>
                                            <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab"><span className="w-100 text-center d-block">No QMS module updates available</span></div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>

        </>
    );

}
export default Dashboard;